import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import { DEFAULT_DATE_FORMAT_SANS_TIME, formatters } from 'common';
import ScrollableTablePanel from 'components/ScrollableTablePanel';
import messages from './messages';


const MarginCallPanel = ({ marginCalls }) => {
  const columns = [
    { name: 'type', label: <FormattedMessage {...messages.type} /> },
    { name: 'date', label: <FormattedMessage {...messages.date} /> },
    { name: 'amount', label: <FormattedMessage {...messages.amount} /> },
  ];
  const rows = marginCalls.map((marginCall) => ({
    ...marginCall,
    type: formatters.formatMarginCallType(marginCall.type),
    amount: formatters.formatDollars(marginCall.amount),
    date: moment(marginCall.issueDate, moment.ISO_8601).format(DEFAULT_DATE_FORMAT_SANS_TIME),
  }));

  return (<ScrollableTablePanel columns={columns} rows={rows} />);
};

MarginCallPanel.propTypes = {
  marginCalls: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    issueDate: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
  })).isRequired,
};


export default MarginCallPanel;



// WEBPACK FOOTER //
// ./src/components/MarginCallPanel/index.js